import styled from '@emotion/styled';
import { Ui } from '@silvertours/front-shared';

const Card = styled(Ui.Card)`
  max-width: 285px;
`;

const Button = styled.button`
  display: grid;
  grid-template-areas: 'logo stars' 'subline subline';
  gap: ${({ theme }) => theme.spacing[20]} ${({ theme }) => theme.spacing[40]};
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: ${({ theme }) => theme.spacing[40]};
  border: 0;
  border-radius: inherit;
  width: 100%;
  font: inherit;
  color: inherit;
  background: none;
  cursor: pointer;

  &:focus-visible {
    outline: 0.125rem dashed ${({ theme }) => theme.color.secondary};
    outline-offset: 0.25rem;
  }
`;

const Subline = styled.div`
  grid-area: subline;
  font-size: ${({ theme }) => theme.fontSize.xxs.size};
  text-align: center;
`;

const SvgContainer = styled.div`
  display: flex;
  align-items: center;

  & > svg {
    width: auto;
    height: 24px;
  }
`;

const LogoContainer = styled(SvgContainer)`
  grid-area: logo;
`;

const StarsContainer = styled(SvgContainer)`
  grid-area: stars;
`;

export { Card, Button, Subline, LogoContainer, StarsContainer };
